import { Pipe, PipeTransform } from '@angular/core';
import { FundType } from '../../../../models/transactions/fund-type';

@Pipe({
  name: 'investmentInstructionFundColour'
})
export class InvestmentInstructionFundColourPipe implements PipeTransform {
  transform(value: FundType): string {
    return value.getChartDataColor();
  }
}
